import { render, staticRenderFns } from "./item-dialog.vue?vue&type=template&id=5da5c540&scoped=true&"
import script from "./item-dialog.vue?vue&type=script&lang=js&"
export * from "./item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./item-dialog.vue?vue&type=style&index=0&id=5da5c540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5c540",
  null
  
)

export default component.exports